import type { ImageSrcsetConfig } from '@/utils/image'

export const DAM_IMAGE_AUTOHEIGHT_WIDTH_DEFAULT = 970
export const DAM_IMAGE_AUTOHEIGHT_HEIGHT_DEFAULT = 0
export const DAM_IMAGE_AUTOHEIGHT_SRCSET_CONFIG: ImageSrcsetConfig = [
  { width: 288, height: 0, widthOrDensity: '288w' },
  { width: 448, height: 0, widthOrDensity: '448w' },
  { width: 608, height: 0, widthOrDensity: '608w' },
  { width: 970, height: 0, widthOrDensity: '970w' },
  { width: 1024, height: 0, widthOrDensity: '1024w' },
]

export const DAM_IMAGE_RATIO4x3_WIDTH_DEFAULT = 600
export const DAM_IMAGE_RATIO4x3_HEIGHT_DEFAULT = 450
export const DAM_IMAGE_RATIO4x3_SRCSET_CONFIG: ImageSrcsetConfig = [
  { width: 120, height: 90, widthOrDensity: '120w' },
  { width: 240, height: 180, widthOrDensity: '240w' },
  { width: 360, height: 270, widthOrDensity: '360w' },
  { width: 480, height: 360, widthOrDensity: '480w' },
  { width: 600, height: 450, widthOrDensity: '600w' },
]

export const DAM_IMAGE_LIGHTBOX_WIDTH_DEFAULT = 2000
export const DAM_IMAGE_LIGHTBOX_HEIGHT_DEFAULT = 0
export const DAM_IMAGE_LIGHTBOX_SRCSET_CONFIG: ImageSrcsetConfig = [
  { width: 608, height: 0, widthOrDensity: '608w' },
  { width: 970, height: 0, widthOrDensity: '970w' },
  { width: 2000, height: 0, widthOrDensity: '2000w' },
]
